import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4e64e0c8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "custom-flag"
};
const _hoisted_2 = ["src"];
import { computed } from "vue";
import MarketFlag from "vue-country-flag-next";
import IntlFlag from "@/assets/flags/flag-international.png";
import LatamFlag from "@/assets/flags/flag-central_america.png";
import HKFlag from "@/assets/flags/flag-hk.png";
import CNFlag from "@/assets/flags/flag-cn.png";
import JPFlag from "@/assets/flags/flag-jp.png";
import KRFlag from "@/assets/flags/flag-kr.png";
import TWFlag from "@/assets/flags/flag-tw.png";
import NorthAsiaFlag from "@/assets/flags/flag-north_asia.png";
import EuropeFlag from "@/assets/flags/flag-europe.png";
import MiddleEastFlag from "@/assets/flags/flag-middle_east.png";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OneDeskCountryFlag',
    props: {
        marketCode: {}
    },
    setup(__props) {
        const props = __props;
        const IsCustomFlag = computed(() => Object.keys(customFlagDict).includes(props.marketCode));
        const customFlagDict = {
            _INTL: IntlFlag,
            _LATAM: LatamFlag,
            _MEA: MiddleEastFlag,
            AA: IntlFlag,
            EU: EuropeFlag,
            "_NORTH ASIA": NorthAsiaFlag,
            _SAPMENA: IntlFlag,
            HK: HKFlag,
            CN: CNFlag,
            JP: JPFlag,
            KR: KRFlag,
            TW: TWFlag
        };
        return (_ctx, _cache) => {
            return (IsCustomFlag.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("img", {
                        src: customFlagDict[_ctx.marketCode],
                        alt: "flag"
                    }, null, 8, _hoisted_2)
                ]))
                : (_openBlock(), _createBlock(_unref(MarketFlag), {
                    key: 1,
                    country: _ctx.marketCode == 'UK' ? 'gb' : _ctx.marketCode
                }, null, 8, ["country"]));
        };
    }
});
